import { useMemo } from "react";
import { useAccounts } from "../accounts";
import { useProducts } from "./useProducts";

function useAccountOptions() {
  const accountsInfo = useAccounts({ fullCreditCardsInfo: true });
  const productsInfo = useProducts();
  const accountOptions = useMemo(() => {
    if (!accountsInfo.data || !productsInfo.data) {
      return [];
    }

    return accountsInfo.data.credit_cards.reduce((acc, account) => {
      if (account.links.length === 0) {
        return acc;
      }

      const product = productsInfo.data.find(
        (p) => p.id === account.product_id,
      );

      if (product?.region === "AU") {
        acc.push({
          data: {
            isOverdue: account.credit_card.amount_overdue > 0,
            cardName: product.name,
            cardEndsWith: account.credit_card.linked_card_last4,
            cardToken: account.credit_card.token,
            westpacUserId: product.westpac_direct_debit_id,
          },
          value: account.account_id,
        });
      }

      return acc;
    }, []);
  }, [accountsInfo.data, productsInfo.data]);

  return {
    isLoading: accountsInfo.isLoading || productsInfo.isLoading,
    isError: accountsInfo.isError || productsInfo.isError,
    accountOptions,
  };
}

export { useAccountOptions };
